// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1a__R","comment":"styles_comment__35QEu"};